<template>
	<div class="scroll">
		<div v-if="cliente && !modoNuevoCliente">
			<div class="decor-btn">
				<el-button class="boton-anterior" circle icon="el-icon-back" @click="$router.back()" />
			</div>
			<!-- VISTA CLIENTE EXISTENTE -->
			<div>
				<h1 class="center">{{ cliente.nombre || 'Cliente' }}</h1>
				<div class="info-cliente">
					<p><strong>Dirección:</strong> {{ cliente.direccion }}</p>
					<p><strong>Documento:</strong> {{ cliente.documento }}</p>
					<p><strong>Fecha:</strong> {{ formatFecha(fechaActual) }}</p>
				</div>
				<!--Compras Anteriores-->
				<div v-if="compras.length">
					<el-divider content-position="center">
						<h2>
							Compras
						</h2>
					</el-divider>
					<div v-if="productos.length" class="info-cliente">
						<h3>Productos</h3>
						<el-table :data="productos" class="tabla-detalle">
							<el-table-column prop="producto" label="Producto" align="center" />
							<el-table-column prop="cantidad" label="Cantidad" align="center" />
							<el-table-column prop="precio" label="Precio" align="center">
								<template #default="scope">
									<span v-if="scope.row.precio != null"> ${{ scope.row.precio.toFixed(2) }} </span>
									<span v-else>-</span>
								</template>
							</el-table-column>
							<el-table-column label="Subtotal" align="center">
								<template #default="scope">
									<span v-if="scope.row.precio != null"> ${{ (scope.row.precio * scope.row.cantidad).toFixed(2) }} </span>
									<span v-else>-</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="info-cliente info-total"><strong>Total:</strong> ${{ totalCompra.toFixed(2) }}</div>
					</div>
					<div v-if="envases.length" class="info-cliente">
						<h3>Envases</h3>
						<el-table :data="envases" class="tabla-detalle">
							<el-table-column prop="producto" label="Envase" align="center" />
							<el-table-column prop="cantidad" label="Cantidad" align="center" />
						</el-table>
					</div>
					<!-- Este es el boton para hacer una compra  extra -->
					<div class="centrar-btn">
						<el-button type="primary" @click="setMostrarFormulario(true)" v-if="!mostrarFormulario && esHoy" class="btn">
							Agregar otra venta
						</el-button>
					</div>
				</div>
				<!-- Compras hace 7 dias -->
				<div v-else-if="comprasHace7Dias.length && esHoy" class="info-cliente">
					<p><strong>Se encontraron compras de hace 7 días:</strong></p>
					<el-table :data="comprasHace7Dias" class="tabla-detalle">
						<el-table-column prop="producto" label="Producto" align="center" />
						<el-table-column prop="cantidad" label="Cantidad" align="center" />
					</el-table>
					<div class="container-btn">
						<el-button type="success" @click="repetirPedido" class="btn-agregar">
							Repetir pedido
						</el-button>
						<el-button type="danger" @click="descartarSugerencia" class="btn-agregar">
							Descartar
						</el-button>
					</div>
				</div>
				<!-- Formulario Nuevo Pedido -->
				<div v-if="mostrarFormulario && esHoy">
					<h3 class="center">Cargar nuevo pedido</h3>
					<el-table :data="nuevoPedido" :row-style="setRowHeight">
						<el-table-column label="Producto">
							<template #default="scope">
								<el-select v-model="scope.row.productoId" placeholder="Seleccione" @change="onProductoSeleccionado(scope.row)">
									<el-option v-for="prod in productosDisponibles" :key="prod.id" :label="prod.nombre" :value="prod.id" />
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="Cantidad">
							<template #default="scope">
								<el-input v-model="scope.row.cantidad" :min="1" />
							</template>
						</el-table-column>
						<el-table-column label="Precio">
							<template #default="scope">
								<span class="center">{{ scope.row.precio || '-' }}</span>
							</template>
						</el-table-column>
						<el-table-column width="50">
							<template #default="scope">
								<el-button @click="eliminarFila(scope.$index)" icon="el-icon-close" circle size="mini" />
							</template>
						</el-table-column>
					</el-table>
					<div class="centrar-btn">
						<el-button type="primary" @click="agregarFilaProducto" icon="el-icon-plus" class="btn">
							Agregar producto
						</el-button>
					</div>
					<div class="centrar-input">
						<el-select v-model="$store.state.detalleCliente.tipoOperacionSeleccionada" placeholder="Tipo de operacion" class="btn">
							<el-option
								v-for="tipo in $store.state.detalleCliente.tiposOperacion"
								:key="tipo.value"
								:label="tipo.descripcion"
								:value="tipo.id"
							/>
						</el-select>
					</div>
					<div class="centrar-btn">
						<el-button
							type="success"
							:loading="cargandoGuardado"
							@click="guardarPedidoConFeedback"
							:disabled="!pedidoValido || cargandoGuardado"
							class="btn"
						>
							Guardar Pedido
						</el-button>
					</div>
				</div>
				<div v-if="!compras.length && !comprasHace7Dias.length && !mostrarFormulario" class="centrar-btn">
					<el-button v-if="esHoy" type="primary" @click="setMostrarFormulario(true)" class="btn">
						Cargar Pedido
					</el-button>
				</div>
			</div>
		</div>
		<!--Modo nuevo cliente-->
		<div v-if="modoNuevoCliente">
			<el-button class="boton-anterior" circle icon="el-icon-back" @click="$router.push({ name: 'Visitas' })" />
			<h2 class="center">Agregar Pedido</h2>
			<!--Seleccion de cliente-->
			<div>
				<div class="centrar-btn">
					<el-button @click="mostrarDialogoAgregarCliente = true" round icon="el-icon-plus" class="btn">
						Agregar Cliente
					</el-button>
				</div>
				<div class="centrar-input">
					<el-select v-model="clienteSeleccionado" placeholder="Selecciona un cliente existente" filterable class="btn">
						<el-option v-for="cliente in clientesDisponibles" :key="cliente.id" :label="cliente.nombre" :value="cliente.id" />
					</el-select>
				</div>
			</div>
			<div class="centrar-btn">
				<el-button type="primary" class="btn" round @click="continuarConClienteExistente">
					Continuar
				</el-button>
			</div>
		</div>
		<!--Dialogo para agregar cliente nuevo-->
		<el-dialog :visible.sync="mostrarDialogoAgregarCliente">
			<template #title>
				<div class="formulario">
					Nuevo cliente
				</div>
			</template>
			<el-input v-model="nuevoCliente.nombre" placeholder="Nombre" />
			<el-input v-model="nuevoCliente.nrodoc" placeholder="DNI" class="formulario-element" />
			<el-input v-model="nuevoCliente.direccion" placeholder="Dirección" class="formulario-element" />
			<span slot="footer" class="container-btn">
				<el-button class="btn-agregar" @click="mostrarDialogoAgregarCliente = false">
					Cancelar
				</el-button>
				<el-button class="btn-agregar" type="primary" @click="crearYContinuar">
					Agregar
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import moment from 'moment';

export default {
	name: 'DetalleCliente',
	data() {
		return {
			modoNuevoCliente: false,
			clienteSeleccionado: null,
			mostrarDialogoAgregarCliente: false,
			nuevoCliente: { nombre: '', nrodoc: '', direccion: '' },
			clientes: [],
			cargandoGuardado: false,
			tipoSeleccionado: null,
		};
	},
	computed: {
		productos() {
			const agrupados = {};
			this.compras.forEach(c => {
				if (!c.es_envase) {
					const key = `${c.producto}-${c.producto_id}`;
					if (!agrupados[key]) {
						agrupados[key] = {
							producto: c.producto,
							cantidad: 0,
							precio: c.precio != null ? c.precio : null,
						};
					}
					agrupados[key].cantidad += c.cantidad;
				}
			});
			return Object.values(agrupados);
		},
		envases() {
			const agrupados = {};
			this.compras.forEach(c => {
				if (c.es_envase) {
					const key = `${c.producto}-${c.producto_id}`;
					if (!agrupados[key]) {
						agrupados[key] = {
							producto: c.producto,
							cantidad: 0,
						};
					}
					agrupados[key].cantidad += c.cantidad;
				}
			});
			return Object.values(agrupados);
		},
		totalCompra() {
			return this.productos.reduce((acc, item) => {
				if (item.precio != null) return acc + item.precio * item.cantidad;
				return acc;
			}, 0);
		},
		...mapState('detalleCliente', ['nuevoPedido']),
		esHoy() {
			const hoy = moment().format('YYYY-MM-DD');
			return this.fechaActual === hoy;
		},
		...mapGetters('detalleCliente', [
			'cliente',
			'compras',
			'comprasHace7Dias',
			'productosDisponibles',
			'mostrarFormulario',
			'fechaActual',
			'clientesDisponibles',
			'productosSeleccionados',
			'pedidoValido',
			'tiposOperacion',
		]),
	},
	methods: {
		onProductoSeleccionado(fila) {
			const producto = this.productosDisponibles.find(p => Number(p.id) === Number(fila.productoId));
			if (producto) fila.precio = producto.precio;
			else {
				fila.precio = 0;
				console.warn(`No se encontró precio para el producto ${fila.productoId}`);
			}
		},
		setRowHeight() {
			return { height: '100px' };
		},
		formatFecha(fecha) {
			return moment(fecha).format('DD/MM/YYYY');
		},
		...mapActions('detalleCliente', [
			'setMostrarFormulario',
			'fetchDetalle',
			'repetirPedido',
			'descartarSugerencia',
			'agregarFilaProducto',
			'eliminarFila',
			'fetchClientes',
			'fetchProductos',
			'resetNuevoPedido',
			'agregarProducto',
			'eliminarProducto',
			'guardarPedido',
			'crearCliente',
			'eliminarCompraDelCliente',
			'obtenerTiposOperacion',
		]),
		async continuarConClienteExistente() {
			if (!this.clienteSeleccionado) return;
			const fecha = this.obtenerFechaActual();
			this.$router.push({ name: 'DetalleCliente', params: { id: this.clienteSeleccionado, fecha } });
		},
		async crearYContinuar() {
			if (!this.nuevoCliente.nombre || !this.nuevoCliente.nrodoc || !this.nuevoCliente.direccion) {
				this.$message.warning('Completá todos los campos antes de continuar');
				return;
			}
			if (!/^\d{7,8}$/.test(this.nuevoCliente.nrodoc)) {
				this.$message.warning('El DNI debe tener entre 7 y 8 dígitos');
				return;
			}
			try {
				const clienteCreado = await this.crearCliente(this.nuevoCliente);
				this.clienteSeleccionado = clienteCreado.id;
				this.mostrarDialogoAgregarCliente = false;
				this.nuevoCliente = { nombre: '', nrodoc: '', direccion: '' };

				const fechaActual = this.obtenerFechaActual();
				this.$router.push({
					name: 'DetalleCliente',
					params: { id: clienteCreado.id, fecha: fechaActual },
				});
			} catch (e) {
				console.error('Error al crear cliente:', e);
			}
		},
		async guardarPedidoConFeedback() {
			this.cargandoGuardado = true;
			try {
				await this.guardarPedido();
				this.$message.success('Pedido guardado correctamente');
				this.$router.push({ name: 'Envases', query: { clienteId: this.cliente.id, fecha: this.fechaActual } });
			} catch (e) {
				this.$message.error('Hubo un error al guardar el pedido');
			} finally {
				this.cargandoGuardado = false;
			}
		},
		obtenerFechaActual() {
			return moment().format('YYYY-MM-DD');
		},
		async manejarRuta() {
			const { id, fecha } = this.$route.params;
			this.resetNuevoPedido();
			if (!this.clientesDisponibles.length) await this.fetchClientes();
			if (!id) {
				this.modoNuevoCliente = true;
				this.setMostrarFormulario(false);
				this.fetchProductos();
				return;
			}
			this.modoNuevoCliente = false;
			this.setMostrarFormulario(false);
			await this.fetchDetalle({ id, fecha });
		},
		//esto se borraria
		async editarCompra() {
			try {
				await this.$store.dispatch('detalleCliente/eliminarCompraDelCliente');
				await this.$store.dispatch('detalleCliente/fetchDetalle', {
					id: this.cliente.id,
					fecha: this.fechaActual,
				});
				this.$message.success('Compra eliminada.');
			} catch (err) {
				this.$message.error('Error al intentar editar la compra.');
				console.error(err);
			}
		},
	},
	mounted() {
		this.obtenerTiposOperacion();
	},
	watch: {
		'$route.params': {
			handler() {
				this.manejarRuta();
			},
			immediate: true,
			deep: true,
		},
	},
	beforeRouteLeave(to, from, next) {
		this.$store.dispatch('detalleCliente/resetState');
		next();
	},
};
</script>
<style scoped>
.scroll {
	overflow-y: auto;
	height: 100vh;
	background-color: white !important;
}
/* CSS de botones */
/* Botón de ir atras */
.decor-btn {
	border-bottom: solid rgb(204, 203, 203) 1px;
}
.boton-anterior {
	margin-left: 5px;
	margin-top: 5px;
	border: none;
}
/* botón general */
.centrar-btn {
	margin: auto;
	width: 50%;
}
.btn {
	margin-top: 20px;
	width: 100%;
	padding: 10px;
}
/* Botonera doble */
.container-btn {
	display: flex;
	justify-content: space-around;
}
.btn-agregar {
	margin-bottom: 1rem;
	margin-top: 10px;
	text-align: center;
	width: 45%;
	padding: 10px;
}
/* CSS de h1,h2,h3 */
h1 {
	font-size: larger;
}
h2 {
	font-size: larger;
}
h3 {
	font-size: large;
}
.tabla-detalle {
	width: 100%;
}
.info-cliente {
	margin: 1px 0;
	padding: 10px;
}
.center {
	text-align: center;
}
.centrar-input {
	margin: auto;
	width: 80%;
}
/* Formulario */
.formulario {
	text-align: left;
	padding-right: 10px;
}
.formulario-element {
	margin-top: 10px;
}
/* borrar cuando saque el boton de eliminar*/
.boton-flotante {
	/* position: fixed !important; */
	top: 1px;
	right: 1px;
	width: 40px;
	height: 40px;
}
.info-total {
	text-align: right;
	margin-top: 10px;
}
</style>
